import React, { useState } from "react";
import skyGardenAmenitiesImg from "../assets/images/amenitiesPic.jpg";
import amenitiesImg from "../assets/images/37thFloorAmenitiesPic.PNG";
import "../assets/css/amenities.css"; // Add custom styles

const Amenities = () => {
    const [selectedFloor, setSelectedFloor] = useState("sky_garden");
    const [floorImg, setFloorImg] = useState(skyGardenAmenitiesImg);

    const skyGardenAmenitiesSpots = [
        { id: 1, name: "Sitting Area", x: "20%", y: "24%" },
        { id: 2, name: "Box Cricket", x: "13%", y: "54%" },
        { id: 3, name: "Yoga", x: "50%", y: "64%" },
        { id: 4, name: "Children Play Area", x: "80%", y: "35%" },
        { id: 6, name: "Acupressure Track", x: "88%", y: "51%" },
        { id: 7, name: "Viewing Desk", x: "79%", y: "23%" },
    ];
    const amenitiesImgSpots = [];

    const [selectedSpots, setSelectedSpots] = useState(skyGardenAmenitiesSpots);

    const changeFloor = (floor) => {
        setSelectedFloor(floor);
        if (floor === "sky_garden") {
            setFloorImg(skyGardenAmenitiesImg);
            setSelectedSpots(skyGardenAmenitiesSpots);
        } else {
            setFloorImg(amenitiesImg);
            setSelectedSpots(amenitiesImgSpots);
        }
    }

    return (
        <div className="amenities-container">
            {/* <TransformWrapper minScale={1} maxScale={3} centerOnInit={true}>
                {({ zoomIn, zoomOut, resetTransform }) => (
                    <>
                        <div className="zoom-controls">
                            <button onClick={() => zoomIn()}>+</button>
                            <button onClick={() => zoomOut()}>-</button>
                            <button onClick={() => resetTransform()}>Reset</button>
                        </div>

                        <TransformComponent>
                            <div className="image-wrapper">
                                <img src={floorImg} alt="Amenities" className="zoomable-image" />

                                {selectedSpots.map((spot) => (
                                    <div
                                        key={spot.id}
                                        className="spot-label"
                                        style={{ left: spot.x, top: spot.y }}
                                    >
                                        {spot.name}
                                    </div>
                                ))}
                            </div>
                        </TransformComponent>
                    </>
                )}
            </TransformWrapper>
            <div className="floor_buttons">
                <ul>
                    <li>
                        <button onClick={() => { changeFloor('sky_garden'); }} className={`${selectedFloor === "sky_garden" ? 'active' : ''}`}>
                            Sky Garden
                        </button>
                    </li>
                    <li>
                        <button onClick={() => { changeFloor('37thfloor'); }} className={`${selectedFloor === "37thfloor" ? 'active' : ''}`}>
                            37th Floor
                        </button>
                    </li>
                </ul>
            </div> */}
            <div className="scrollable-wrapper">
                <div className={`image-wrapper ${selectedFloor !== "sky_garden" && 'amenities_37_image'}`}>
                    <img src={floorImg} alt="Amenities" className="responsive-image" />
                    {selectedSpots.map((spot) => (
                        <div
                            key={spot.id}
                            className="spot-label"
                            style={{ left: spot.x, top: spot.y }}
                        >
                            {spot.name}
                        </div>
                    ))}
                </div>
            </div>

            <div className="floor_buttons amenities_buttons">
                <ul>
                    <li>
                        <button
                            onClick={() => changeFloor("sky_garden")}
                            className={selectedFloor === "sky_garden" ? "active" : ""}
                        >
                            Sky Garden
                        </button>
                    </li>
                    <li>
                        <button
                            onClick={() => changeFloor("37thfloor")}
                            className={selectedFloor === "37thfloor" ? "active" : ""}
                        >
                            37th Floor
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default Amenities;
